export default {
  state: {
    categories: [],
    searchList: [],
    popularList: [],
    tagList: [],
    tags: [],
  },
  mutations: {
    SET_BLOGTAG_LIST(state, blogs) {
      var bs = [];
      for (let blog of blogs) {
        var b = blog;
        b.thumb_url = blog.thumb_url.replace(' ', '%20');
        bs.push(b);
      }
      state.tagList = bs;
    },
    SET_BLOG_LIST(state, blogs) {
      var bs = [];
      for (let blog of blogs) {
        var b = blog;
        b.thumb_url = blog.thumb_url.replace(' ', '%20');
        bs.push(b);
      }
      state.searchList = bs;
    },
    SET_BLOG_POPULAR(state, blogs) {
      state.popularList = blogs;
    },
    SET_BLOG_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_BLOG_TAGS(state, tags) {
      state.tags = tags;
    },
  },
  actions: {},
  getters: {},
};
